var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.86597,
    y: 1.30385,
    width: 12,
    height: 2,
    rx: 1,
    transform: "rotate(60 4.86597 1.30385)",
    fill: "#FFFFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.866,
    y: 2.30385,
    width: 12,
    height: 2,
    rx: 1,
    transform: "rotate(120 10.866 2.30385)",
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.25C3 3.97386 3.22386 3.75 3.5 3.75H5V4.75H3.5C3.22386 4.75 3 4.52614 3 4.25Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81699 2.25C7.05613 2.38807 7.13807 2.69387 7 2.93301L6.25 4.23205L5.38397 3.73205L6.13397 2.43301C6.27205 2.19387 6.57784 2.11193 6.81699 2.25Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47293 9.1806C2.23378 9.04253 2.15185 8.73674 2.28992 8.49759L3.03992 7.19855L3.90594 7.69855L3.15594 8.99759C3.01787 9.23674 2.71208 9.31867 2.47293 9.1806Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43295 4.75C2.6721 4.61193 2.9779 4.69387 3.11597 4.93301L3.86597 6.23205L2.99994 6.73205L2.24994 5.43301C2.11187 5.19387 2.19381 4.88807 2.43295 4.75Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.683 4.75C11.9221 4.88807 12.004 5.19387 11.866 5.43301L11.116 6.73205L10.2499 6.23205L10.9999 4.93301C11.138 4.69387 11.4438 4.61193 11.683 4.75Z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7229 9.1806C11.4838 9.31867 11.178 9.23674 11.0399 8.99759L10.2899 7.69855L11.1559 7.19855L11.9059 8.49759C12.044 8.73674 11.9621 9.04253 11.7229 9.1806Z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.75C11 10.0261 10.7761 10.25 10.5 10.25L9 10.25L9 9.25L10.5 9.25C10.7761 9.25 11 9.47386 11 9.75Z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.25L3.5 10.25C3.22386 10.25 3 10.0261 3 9.75C3 9.47386 3.22386 9.25 3.5 9.25L5 9.25L5 10.25Z",
    fill: "#FFFFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.23206L7.25 2.93302C7.11193 2.69387 7.19387 2.38808 7.43301 2.25C7.67216 2.11193 7.97795 2.19387 8.11603 2.43302L8.86603 3.73206L8 4.23206Z",
    fill: "#FFFFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43301 11.9821C7.19387 11.844 7.11193 11.5382 7.25 11.299L8 10L8.86603 10.5L8.11603 11.799C7.97795 12.0382 7.67216 12.1201 7.43301 11.9821Z",
    fill: "#FFFFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10L7 11.299C7.13807 11.5382 7.05613 11.844 6.81699 11.9821C6.57784 12.1201 6.27205 12.0382 6.13397 11.799L5.38397 10.5L6.25 10Z",
    fill: "#FFFFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.25C11 4.52614 10.7761 4.75 10.5 4.75L9 4.75L9 3.75L10.5 3.75C10.7761 3.75 11 3.97386 11 4.25Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCold);
export default __webpack_public_path__ + "static/media/cold.1c02e09c6c20f5ba7329ff2e4df9d8a5.svg";
export { ForwardRef as ReactComponent };